


















































































































































  import { Vue, Component, Watch } from "vue-property-decorator";
  import { Popup, Picker, DatetimePicker, Calendar, Field, Tag, Tab,Tabs } from "vant";
  import productHome from "../modules/productHome.vue";
  import { ApplyArea, Cabin, VoyageType, YesOrNo, ZoneType } from "@/model/Base";
  import dataShare from "../dataShare";
  import * as _ from "lodash";
  import billService from "@/service/billService";
  import { TradeDetailEntity } from "@/model/Bill";
  // import RetainTickets from "./modules/RetainTickets.vue";
  import RetainTickets from "./modules/RetainTickets.vue";
  import huilianyiService from "@/service/huilianyiService";
  import flightService from "@/service/flightService";
  import SystemService from "@/service/UserService";

import moment from "moment";
  @Component({
    components: {
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [DatetimePicker.name]: DatetimePicker,
      [Calendar.name]: Calendar,
      [Field.name]: Field,
      [Tag.name]: Tag,
      [Tab.name]: Tab,
      [Tabs.name]:Tabs,
      // [Dialog.name]: Dialog as any,
      "product-home": productHome,
      ["retain-tickets"]: RetainTickets,
    },
  })
  export default class Flight extends Vue {
    //data
    arrivePopupVisible = false;
    departPopupVisible = false;
    cabinPopupVisible = false;
    cabins = [
      { text: this.$root.$t("mall_flight_flight_toudengcang") as string, value: Cabin.First },
      { text: this.$root.$t("mall_flight_flight_shangwucang") as string, value: Cabin.Buissenes },
      { text: this.$root.$t("mall_flight_flight_jingjicang") as string, value: Cabin.Economy },
    ];

    VoyageTypes = [
      { text: this.$root.$t("mall_flight_flight_dancheng") as string, value: VoyageType.SingleVoyage, className: "oneWay" },
      { text: this.$root.$t("mall_flight_flight_wangfan") as string, value: VoyageType.RoundVoyage, className: "roundTrip" },
    ];

    citys = [
      { text: this.$root.$t("mall_flight_flight_shanghai") as string, code: "SHA", CountryID: 151 },
      { text: this.$root.$t("mall_flight_flight_beijing") as string, code: "BJS", CountryID: 151 },
      { text: this.$root.$t("mall_flight_flight_guangzhou") as string, code: "CAN", CountryID: 151 },
    ];

    dataShare = dataShare;
    datePickerVisible = false;
    DepartDate = new Date();
    ArriveDate: Date | null = null;

    // selectedCabin = this.cabins[0];
    selectedCabin = {};
    departCity = this.citys[0];
    arriveCity = this.citys[1];
    get ApplyArea() {
      if (this.departCity && this.departCity.CountryID && this.departCity.CountryID != 151) {
        return ApplyArea.Overseas;
      }
      if (this.arriveCity && this.arriveCity.CountryID && this.arriveCity.CountryID != 151) {
        return ApplyArea.Overseas;
      }
      return ApplyArea.Internal;
    }
    query: any = {
      DepartDate: undefined,
      ArriveDate: undefined,
      DepartCity: this.departCity.code,
      ArriveCity: this.arriveCity.code,
      DepartCityName: this.departCity.text,
      ArriveCityName: this.arriveCity.text,
      ApplyArea: this.ApplyArea,
      BookingType: "1529",
      VoyageType: 1161,
      BerthLevel: '',
      ServiceType: "FlightService",
      AdultCount: 1,
      ChildCount: 0,
      InfantCount: 0,
      FeatureCodes: "",
      Consumers: "",
    };
    ymdDate = "YYYY-MM-DD";
    mdDate = this.$root.$t("mall_flight_flight_yueri") as string;
    changeCityFlag = false;
    OneSelf = null;

    get City(): any {
      return this.dataShare.City;
    }
    set City(value: any) {
      this.dataShare.City = value;
    }
    get ShowApproval(){
      return this.oldApprovalList?.some((item:any)=>item.travelFlightsList);
    }
    get defaultDate (){
      return this.query.VoyageType == this.VoyageTypes[0].value ? moment(this.DepartDate).toDate() : [moment(this.DepartDate).toDate(), moment(this.ArriveDate).toDate()]
    }
    mounted() {
      const __self = this;
      this.City = null;
      this.dataShare.consumers = [];
      this.loadRetainTickets();
      this.searchapproval();
      this.getApprovalExtra();
    }

    //activated
    activated() {
      // this.Consumers = dataShare.consumers;
      if (this.selectCode && this.City && this.City.value) {
        let City = this.City;
        if (this.selectCode == "DepartCity") {
          this.departCity = this.City;
          this.query.DepartCityName = City.label;
          this.query.DepartCity = City.value;
          this.query.DepartCode = City.ZoneType == ZoneType.Airport ? City.ZoneCode : null;
        } else if (this.selectCode == "ArriveCity") {
          this.arriveCity = this.City;
          this.query.ArriveCityName = City.label;
          this.query.ArriveCity = City.value;
          this.query.ArriveCode = City.ZoneType == ZoneType.Airport ? City.ZoneCode : null;
        }
        // 选择完成后清空
        this.selectCode = ''
      }
    }

    //methods
    flightFormatter(day?: any) {
      if (day.type === "start") {
        day.bottomInfo = "去程";
      } else if (day.type === "end") {
        day.bottomInfo = "返程";
      }
      return day;
    }
    showConsumers() {
      let Flag = true;
        if(this.OneSelf == YesOrNo.Yes){
          let consumers: any = [
          {
            RoleID: this.profile.UserID,
            RoleName: this.profile.UserName,
          },
          ];
          dataShare.consumers = consumers;
          return (Flag = false);
        }
      return Flag;
    }
    OneSelfs(value: any) {
      this.OneSelf = value;
    }
    @Watch("dataShare.consumers")
    handelConsumers(value: any) {
      this.Consumers = dataShare.consumers;
    }
    formatDate(value: Date, format: string = this.$root.$t("mall_flight_flight_yueri") as string) {
      if (!value) {
        return value;
      }
      return (this as any).$moment(value).format(format);
    }

    onCabinSelect(cabin: any) {
      this.cabinPopupVisible = false;
      this.selectedCabin = cabin;
      this.query.BerthLevel = cabin.value;
    }
    changeVoyageType(voyageType: number) {
      this.query.VoyageType = voyageType;
      if (voyageType == VoyageType.RoundVoyage) {
        this.ArriveDate = (this as any).$moment(this.DepartDate).add(1, "days");
      } else {
        this.ArriveDate = null;
      }
    }
    handleSelect(data: Date | Array<Date>) {
      this.datePickerVisible = false;
      if (data instanceof Array && data.length == 2) {
        this.DepartDate = data[0];
        this.ArriveDate = data[1];
      } else if (data instanceof Date) {
        this.DepartDate = data;
      }
    }
    search() {
      // 判断起飞/到达时间是否属于审批单某一个区间内
      // if(this.isApproval){
      //   // 判断起飞到达是否有一个在审批单航程中
      //   if(this.CityCodeList.length> 0 && !this.CityCodeList.includes(this.query.DepartCity) && !this.CityCodeList.includes(this.query.ArriveCity)){
      //     return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_shenpidanhangcheng") as string);
      //   }
      //   if(this.query.VoyageType == VoyageType.SingleVoyage && !this.isDateInSections(this.DepartDate,'depart')){
      //     return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_shenpidanchufariqi") as string);
      //   }
      //   if(this.query.VoyageType == VoyageType.RoundVoyage && (!this.isDateInSections(this.DepartDate,'depart') || !this.isDateInSections(this.ArriveDate,'arrive'))){
      //     return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_shenpidanchufadaoda") as string);
      //   }
      // }
      if (this.Consumers.length == 0) {
        return this.$root.$toast.fail(this.$root.$t("mall_flight_flight_qingxuanzelvke") as string);
      }
      this.query.DepartDate = this.formatDate(this.DepartDate, this.ymdDate);
      if (this.ArriveDate) {
        this.query.ArriveDate = this.formatDate(this.ArriveDate, this.ymdDate);
      }
      this.query.Consumers = JSON.stringify(this.Consumers.map((o: any) => ({ ConsumerID: o.RoleID, ConsumerName: o.RoleName })));
      if (dataShare.bookingType) {
        this.query.BookingType = dataShare.bookingType;
      }
      this.query.ApplyArea = this.ApplyArea;
      if (this.ApplyArea == 1126) {
        this.query.BerthLevel = "";
      }
      if(this.ApplyArea == 1127){
        this.query.AdultCount = this.query.Consumers.length;
      }
     if(this.approvalCode) this.query.approvalCode = this.approvalCode;
      this.$router.push({ path: "flight/list", query: this.query as any });
    }

    selectCode = "";
    selectCity(cityType: string) {
      this.City = null;
      this.selectCode = cityType;
      this.$router.push({
        path: "/selectAirport",
        query: {
          ServiceType: this.query.ServiceType,
          ApplyArea: this.query.ApplyArea + "",
        },
      });
    }
    timeSelect(value: string) {
      if (value == "Arrive" && this.query.VoyageType == 1161) {
        return;
      }
      this.datePickerVisible = true;
    }
    changeCity() {
      this.changeCityFlag = !this.changeCityFlag;
      const newArriveCity = this.query.ArriveCity;
      const newArriveCityName = this.query.ArriveCityName;
      this.query.ArriveCity = this.query.DepartCity;
      this.query.ArriveCityName = this.query.DepartCityName;
      this.query.DepartCity = newArriveCity;
      this.query.DepartCityName = newArriveCityName;
    }

    Consumers = [];
    //选择乘客
    gotoAddPassengers() {
      dataShare.consumers = this.Consumers;
      this.$router.push("addPassengers");
    }
    //取消选择旅客
    closeBar(consumer: object) {
      this.Consumers = _.difference(this.Consumers, [consumer]) as any;
    }

    RetainTickets: TradeDetailEntity[] = [];
    loadRetainTickets() {
      let __self = this;
      let data = {
        Consumers: [],
        ConsumerCityCode: "",
        FinishedCityCode: "",
        BookingUserID: __self.profile.UserID,
      };
      billService.getUserTicketStatus(data).then(json => {
        if (json.isSucc && json.result) {
          __self.RetainTickets = json.result;
        }
      });
    }
    approvalList:any = [];
    oldApprovalList:any = [];
    searchapproval() {
       let __self = this;
       huilianyiService.searchapprovals().then((res:any) => {
         __self.approvalList = res.result || [];
         __self.approvalList = __self.approvalList.map((item:any) => {
            const guestNames = item.participantList.map((item:any) => item.name).join(',');
            return {...item, guestNames, isCheck: false};
          }).filter((i:any) => i.travelFlightsList);
          __self.oldApprovalList = JSON.parse(JSON.stringify(__self.approvalList));
          __self.approvalList = __self.oldApprovalList.filter((i:any) => i.approvalStatus == 2);
          __self.initBooking();
       });
    }
    initBooking(){
        let __self = this;
        const approvalCode = __self.$route.query.approvalCode;
        if(approvalCode){
            const approvalInfo = __self.approvalList.find((item:any) => item.approvalCode === approvalCode);
            if(approvalInfo){
            // 其余项禁用
            __self.approvalList.forEach((item:any) => {
                if(item.approvalCode === approvalCode) item.isCheck = true;
            });     
            __self.oldApprovalList = JSON.parse(JSON.stringify(__self.approvalList));
            __self.echoSearchInfo(approvalInfo);
            };  
        }
    }
    CityCodeList:any[]=[];
    DepartDateSection:any[]=[];
    ArriveDateSection:any[]=[];
    approvalCode:string = '';
    echoSearchInfo(data:any){
      let __self = this;
      const travelFlightsList = data.travelFlightsList;
      travelFlightsList.forEach((item:any) => {
        __self.CityCodeList.push(item.fromCityCode,item.toCityCode);
        __self.DepartDateSection.push({
          startDate:item.takeOffBeginTime ? moment(item.takeOffBeginTime).valueOf() : 'ALL', 
          endDate:item.takeOffEndTime ? moment(item.takeOffEndTime).valueOf() : 'ALL'
        })
        __self.ArriveDateSection.push({
          startDate:item.arrivalBeginTime ? moment(item.arrivalBeginTime).valueOf() : 'ALL', 
          endDate:item.arrivalEndTime ? moment(item.arrivalEndTime).valueOf():'ALL'
        })
      });
      __self.approvalCode = data.approvalCode;
      __self.Consumers = data.participantList.map((item:any)=>{
        return { RoleID: item.ConsumerID, RoleName: item.name }
      });
      // 去重处理
      __self.CityCodeList = _.uniq(__self.CityCodeList);
      // 默认去第一段航程
      const flightInfo = travelFlightsList[0];
      __self.query.BerthLevel = '';
      // __self.query.BookingType = Number(queryData.BookingType);
      if (flightInfo.fromCity != "" && flightInfo.fromCity != undefined) {
        let departCity = {
          text: flightInfo.fromCity,
          code: flightInfo.fromCityCode,
          CountryID: flightInfo.fromCountryID,
        };
        
        __self.departCity = departCity;
        __self.query.DepartCity = flightInfo.fromCityCode;
        __self.query.DepartCityName = flightInfo.fromCity;
      }
      if (flightInfo.ArriveCity != "" && flightInfo.ArriveCity != undefined) {
        let arriveCity = {
          text: flightInfo.toCity,
          code: flightInfo.toCityCode,
          CountryID: flightInfo.toCountryID,
        };
        __self.arriveCity = arriveCity;
        __self.query.ArriveCity = flightInfo.ArriveCity;
        __self.query.ArriveCityName = flightInfo.ArriveCityName;
      }
      __self.query.ApplyArea = __self.ApplyArea;
      if (flightInfo.takeOffBeginTime || flightInfo.takeOffBeginTime != "") {
        __self.query.DepartDate = flightInfo.takeOffBeginTime;
        __self.DepartDate = flightInfo.takeOffBeginTime;
        __self.query.ArriveDate = '';
        __self.ArriveDate = null;
      }
      // 往返程给返程赋值
      if (flightInfo.itineraryType === 1002 && (flightInfo.arrivalBeginTime || flightInfo.arrivalBeginTime != "")) {
        __self.query.ArriveDate = flightInfo.arrivalBeginTime;
        __self.ArriveDate = flightInfo.arrivalBeginTime;
      }
      if (flightInfo.itineraryType === 1002) {
        __self.query.voyageType = VoyageType.RoundVoyage;
      } else {
        __self.query.voyageType = VoyageType.SingleVoyage;
      }
      // 直接执行查询
      __self.search();
    }
    isDateInSections(tiem:Date | null, sectionType:string) {
      if (!tiem) {
        return false;
      }
      const timestamp = moment(tiem).valueOf();
      const sections = sectionType === 'depart' ? this.DepartDateSection : this.ArriveDateSection;
      return sections.some(section => {
        // 处理可能的无效数据
        if (!section || !section.startDate || !section.endDate) {
          return false;
        }

        // 如果 startDate 和 endDate 都是 'ALL'，则直接满足条件
        if (section.startDate === 'ALL' && section.endDate === 'ALL') {
          return true;
        }

        // 如果只有 startDate 是 'ALL'，则只需要验证 endDate
        if (section.startDate === 'ALL') {
          return timestamp <= Number(section.endDate);
        }

        // 如果只有 endDate 是 'ALL'，则只需要验证 startDate
        if (section.endDate === 'ALL') {
          return timestamp >= Number(section.startDate);
        }

        // 都不是 'ALL' 的情况下，进行常规范围检查
        const start = Number(section.startDate);
        const end = Number(section.endDate);
        const checkTime = Number(timestamp);

        // 检查是否为有效数字
        if (isNaN(start) || isNaN(end) || isNaN(checkTime)) {
          return false;
        }

        return checkTime >= start && checkTime <= end;
      });
    }
    resetSeatClass(type:number){
      if(type == 1) return this.$root.$t("mall_flight_flight_toudengcang") as string;
      if(type == 2) return this.$root.$t("mall_flight_flight_shangwucang") as string;
      if(type == 3) return this.$root.$t("mall_flight_flight_jingjicang") as string;
      if(type == 4) return this.$root.$t("mall_flight_flight_chaojijingjicang") as string;
    }
    activeStatus:number = 2;
    tabChange(status:number){
      this.approvalList = this.oldApprovalList.filter((i:any) => i.approvalStatus == status);
    }
    async goDetail(item:any) {
          // 检查item参数是否存在
          if (!item) {
              this.$root.$toast.fail('参数错误：订单信息不存在');
              return;
          }
          // 检查approvalCode是否存在
          if (!item.approvalCode) {
              this.$root.$toast.fail('参数错误：缺少审批编码');
              return;
          }
          // 根据订单类型选择对应的API
          let OrderID;
          if (!item.travelFlightsList.length) return;
              const res = await flightService.getFlightOrderID(item.approvalCode);
              if (!res.isSucc) {
                this.$root.$toast.fail('获取订单ID失败！');
                return;
              }
          OrderID = res.result;          
          // 跳转到订单详情页
          this.$router.push({
              path: '/order/detail',
              query: {
                  OrderID
              }
          });
    }
    disabledSearch:boolean = false;
    getApprovalExtra(){
      let __self=this;
      let data={
        ExtraCode:'company.ApprovalInfoSetting',
        MasterID:__self.profile.CompanyID || ''
      };
      SystemService.getCompanyExtra(data).then(p=>{
        if(p.isSucc){
          const data=p.result;
          if(data && data.ExtraData){
            __self.disabledSearch=data.ExtraData.indexOf('selectApprovalBooking')>-1 || false;
          }
        }
      })
    }
  }
